import {
  AppBar,
  Toolbar,
  Avatar,
  IconButton,
  Menu,
  MenuItem,
  Box,
  Typography,
  Container,
  Button,
  useScrollTrigger,
  alpha,
  useTheme,
} from "@mui/material";
import MenuIcon from '@mui/icons-material/Menu';
import MemoryIcon from '@mui/icons-material/Memory';
import LogoutIcon from '@mui/icons-material/Logout';
import { useNavigate, Link as RouteLink } from "react-router-dom";
import { useAuth } from "@/hooks";

import React from 'react';

import { useSettings } from "@/app/contexts/SettingContext";

export const Header = () => {
  const settings = useSettings();
  const pages = ['Services', 'Industries', 'Academy'];
  const navigate = useNavigate();
  const scrolled = useScrollTrigger({ disableHysteresis: true, threshold: 12 });
  const theme = useTheme();
  const isDark = theme.palette.mode === 'dark';
  const settingMenu = [{
    item: "Profile",
    onClick:(() => navigate('/profile'))
  }];
  const { isAuthenticated, user, logout } = useAuth();
  const [anchorElUser, setAnchorElUser] = React.useState<null | HTMLElement>(null);
  const [anchorElNav, setAnchorElNav] = React.useState<null | HTMLElement>(null);

  const handleLogout = async () => {
    setAnchorElUser(null);
    await logout();
    navigate('/auth/login');
  };

  const handleOpenNavMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElNav(event.currentTarget);
  };
  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };

  return (
    <AppBar
      position="sticky"
      sx={{
        top: 0,
        bgcolor: scrolled ? alpha(theme.palette.background.default, isDark ? 0.84 : 0.9) : theme.palette.background.default,
        color: theme.palette.text.primary,
        borderBottom: `1px solid ${theme.palette.divider}`,
        boxShadow: scrolled ? theme.palette.baseShadow : 'none',
        backdropFilter: scrolled ? 'blur(18px)' : 'none',
      }}
    >
      <Container maxWidth="lg">
        <Toolbar disableGutters sx={{
          gap: 2,
          minHeight: { xs: 64, md: 74 },
        }}>
          <Box
            sx={{ 
              order: { xs: 1, md: 0 },
              flexGrow: { xs: 1, md: 0 },
            }}  
          >
            <Box 
              component={RouteLink}
              to="/"
              sx={{
                alignItems: 'center', 
                display: 'flex', 
                textDecoration: 'none',
                color: 'inherit',
              }}
            >
              <Box 
                component="img"
                src="/img/crazymodifier-enterprises-logo.png"
                alt="Example"
                sx={{
                  width: 70,
                  height: 'auto',
                  mr: 1
                }}/>
              <Typography 
                variant="h3" 
                sx={{
                  fontWeight:600
                }}
                >
                {settings?.site_name || 'CrazyModifier'}
              </Typography>
            </Box>
          </Box>

          <Box sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none' },order: 0, }}>
            <IconButton
              size="large"
              aria-label="account of current user"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              onClick={handleOpenNavMenu}
              color="inherit"
              sx={{
                padding: 0,
                color: 'text.primary',
              }}
            >
              <MenuIcon />
            </IconButton>
            <Menu
              id="menu-appbar"
              anchorEl={anchorElNav}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
              }}
              keepMounted
              transformOrigin={{
                vertical: 'top',
                horizontal: 'left',
              }}
              open={Boolean(anchorElNav)}
              onClose={handleCloseNavMenu}
              sx={{ display: { xs: 'block', md: 'none' } }}
            >
              {pages.map((page) => (
                <MenuItem
                  key={page}
                  onClick={handleCloseNavMenu}
                  component="a"
                  href={page === 'Home' ? '/' : `#${page.toLowerCase()}`}
                >
                  <Typography sx={{ textAlign: 'center' }}>{page}</Typography>
                </MenuItem>
              ))}
            </Menu>
          </Box>
          <Box 
            sx={{ 
              flexGrow: 1, 
              display: { xs: 'none', md: 'flex' },
              justifyContent: 'end'
            }}
          >
            {pages.map((page) => (
              <Button
                key={page}
                component="a"
                href={page === 'Home' ? '/' : `#${page.toLowerCase()}`}
                onClick={handleCloseNavMenu}
                sx={{
                  color: 'text.secondary',
                  fontWeight: 700,
                  textTransform: 'none',
                  '&:hover': {
                    color: 'text.primary',
                    bgcolor: alpha(theme.palette.secondary.main, 0.08),
                  },
                }}
              >
                {page}
              </Button>
            ))}
          </Box>
          {/* 
          {isAuthenticated ? (
            <Box sx={{ flexGrow: 0,  order: 2,  }}>
              <Avatar
                onClick={(e) => setAnchorElUser(e.currentTarget)}
                sx={{ width: 40, height: 40, cursor: 'pointer', bgcolor: 'secondary.main' }}
              >
                {user?.name?.charAt(0).toUpperCase()}
              </Avatar>
              <Menu
                sx={{ mt: '45px' }}
                anchorOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
                keepMounted
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
                anchorEl={anchorElUser}
                open={Boolean(anchorElUser)}
                onClose={() => setAnchorElUser(null)}>
                <MenuItem disabled>
                    <Box>
                      <Box sx={{ fontWeight: 500 }}>{user?.name}</Box>
                      <Box sx={{ fontSize: '0.85rem', color: '#6b7280' }}>{user?.email}</Box>
                    </Box>
                  </MenuItem>
                {settingMenu.map((setting) => (
                  <MenuItem key={setting.item} onClick={setting.onClick}>
                    <Typography sx={{ textAlign: 'center' }}>{setting.item}</Typography>
                  </MenuItem>
                ))}
                <MenuItem onClick={handleLogout}>
                  <LogoutIcon sx={{ mr: 1 }} /> Logout
                </MenuItem>
              </Menu>
            </Box>
          ):(
            <Box sx={{ flexGrow: 0, order: 2 }}>
              <Button
                component={RouteLink}
                to="/auth/login"
                variant="outlined"
                sx={{
                  color: 'text.primary',
                  borderColor: alpha(theme.palette.primary.main, 0.58),
                  textTransform: 'none',
                  fontWeight: 800,
                  '&:hover': {
                    borderColor: 'primary.main',
                    bgcolor: alpha(theme.palette.primary.main, 0.1),
                  },
                }}
              >
                Login
              </Button>
            </Box>
          )}
           */}
        </Toolbar>
      </Container>
    </AppBar>
  );
};

export default Header;
